import type { Issue } from '../types/issue';
import { num, secondsToDays } from './format';
import { isRefined, isDone } from './status';

// PlanSource:
//   refined — gepflegte Schätzung (SP oder Estimate)
//   rough   — Rough Estimation auf Epic-Ebene
//   actual  — geloggte Zeit (Time Spent)
//   missing — kein Wert pflegbar
export type PlanSource = 'refined' | 'rough' | 'actual' | 'missing';

export type PlanInfo = {
  val: number;          // Personentage
  src: PlanSource;
  label: string;        // anzeigbar in Tooltips / Detail-Sicht
};

// SP→PT-Faktor: 1 SP = factor PT. Default 1.0 (also SP=PT 1:1).
export function computePlan(row: Issue, factor = 1.0): PlanInfo {
  const sp    = num(row['Custom field (Story Points)']);
  const est   = secondsToDays(row['Σ Original Estimate'] ?? row['Original Estimate']);
  const rough = num(row['Custom field (Rough Estimation (d))']);
  const status = row['Status'];

  if (isRefined(status ?? '')) {
    if (sp != null && sp > 0)   return { val: sp * factor, src: 'refined', label: 'Story Points' };
    if (est != null && est > 0) return { val: est,          src: 'refined', label: 'Estimate' };
    if (rough != null)          return { val: rough,        src: 'rough',   label: 'Rough' };
    return { val: 0, src: 'missing', label: '–' };
  }
  if (rough != null)            return { val: rough,        src: 'rough',   label: 'Rough' };
  if (sp != null && sp > 0)     return { val: sp * factor,  src: 'refined', label: 'SP' };
  if (est != null && est > 0)   return { val: est,          src: 'refined', label: 'Est' };
  return { val: 0, src: 'missing', label: '–' };
}

export function computeActual(row: Issue, plan: PlanInfo): PlanInfo {
  const ts = secondsToDays(
    row['Σ Time Spent'] ?? row['Time Spent'] ?? (row as Record<string, unknown>)['Σ Σ Time Spent']
  );
  const status = row['Status'];
  if (isDone(status ?? '')) {
    if (ts != null && ts > 0) return { val: ts, src: 'actual', label: 'Geloggt' };
    return { val: plan.val, src: 'actual', label: 'Plan = Ist' };
  }
  // Nicht-done → Ist-Prognose = aktueller Plan
  return { val: plan.val, src: plan.src, label: plan.label };
}
